import { MicFailure } from '../audio/learn_mic_capture.ts';
import { failureScreenIds, failureSubtext, LearnFailureScreen } from '../learn_failure_screen.tsx';

// The ids the shared failure screen renders for this exercise; the screen itself builds them from
// the same helper, so nothing here is a string that only happens to match (issue #3518).
const ids = failureScreenIds('range');
export const rangeFailureScreenId = ids.screen;
export const rangeFailureBackButtonId = ids.back;

// A microphone the exercise cannot use is the end of the run, and the only end there is (issue
// #3510): the singer is told what went wrong in one line and let out, rather than being asked to
// try again on a screen that cannot know whether anything changed. A denied microphone's line
// points them to their settings (issue #3822), so the next visit can work. Nothing the singer
// sings can land them here.
export const micFailurePrompt = 'We need the microphone to find your range';
// Breaks after "microphone", so neither line ends on a dangling "to" (measured on a 390 px phone)
export const micFailurePromptWidthInChars = 19;

// The line under the prompt is shared with the other listening exercises (issues #3481, #3510,
// #3518); re-exported here so the Range Finder's screens and stories keep reading it from this file
export const micFailureSubtext: Record<MicFailure, string> = failureSubtext;

// The failure state of the Range Finder: the shared Learn failure screen with this exercise's
// prompt, and no Try again, since there is nothing to try again; its way back is named by the page,
// as the result screen's is. Presentational.
export const RangeFailureScreen = ({
  failure,
  backLabel,
  onBack,
}: {
  failure: MicFailure;
  backLabel: string;
  onBack: () => void;
}) => (
  <LearnFailureScreen
    failure={failure}
    idPrefix="range"
    prompt={micFailurePrompt}
    promptWidthInChars={micFailurePromptWidthInChars}
    backLabel={backLabel}
    onBack={onBack}
  />
);
